import * as React from 'react';
import { Loader } from '../../../../view/components/loader/Loader';

export const PropertyList = () => {

	// Redirect anyone who lands on this page to Property Portal
	// This page is no value to admins and allowing access will just cause confusion
	window.location.assign(`${window.location.origin}/properties/overview`);
	return <Loader loading={true} />;
};
